<template>
  <!-- 公告信息发布页面 -->
  <div class="page-container">
    <!-- 页面头部 -->
    <div>
      <div class="page-card__header">
        <span style="padding-right: 20px"> 公告信息发布</span>
      </div>
    </div>
    <!-- 公告表单区域 -->
    <div style="padding: 20px">
      <el-form label-width="100px" :model="form" ref="form" :rules="rules">
        <!-- 新闻类型选择 -->
        <el-form-item label="新闻类型" prop="type" style="text-align: left">
          <el-radio-group v-model="form.type" prop="type">
            <el-radio :label="1">小程序</el-radio>
            <el-radio :label="2">展商</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 公告标题 -->
        <el-form-item label="公告标题" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <!-- 封面图上传 -->
        <el-form-item prop="img" label="封面图" style="text-align: left">
          <el-image
            v-if="form.img !== ''"
            :src="imgUrl + form.img"
            style="width: 120px; height: 90px"
          ></el-image>
          <el-upload
            class="avatar-uploader"
            :action="imagesrc"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :headers="headers"
            :before-upload="beforeAvatarUpload"
          >
            <el-button size="small" type="primary" round
              >点击上传封面图</el-button
            >
            <div slot="tip" class="el-upload__tip">
              最佳展示尺寸：1:1，建议500 x 500像素以上
            </div>
          </el-upload>
        </el-form-item>
        <!--        <el-form-item label="公告内容" prop="info">-->
        <!--          <vue-editor v-model="form.info" @image-added="handleImageAdded" useCustomImageHandler-->
        <!--          ></vue-editor>-->
        <!--        </el-form-item>-->
        <!-- 公告内容编辑 -->
        <el-form-item label="公告内容" prop="info">
          <vue-html5-editor
            :content="form.info"
            :height="300"
            v-model="form.info"
            :show-module-name="showModuleName"
            @change="updateData"
            ref="editor"
          ></vue-html5-editor>
        </el-form-item>
        <!-- 提交按钮 -->
        <el-form-item>
          <el-button type="primary" round size="small" @click="onBaseSubmit('form')"
            >保存发布</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";

import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      form: {
        title: "",
        info: "",
        type: 1,
        img: "",
      },
      showModuleName: true,
      content: "",
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
            ["blockquote", "code-block"], // 引用  代码块
            [{ header: 1 }, { header: 2 }], // 1、2 级标题
            [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
            [{ script: "sub" }, { script: "super" }], // 上标/下标
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            [{ direction: "rtl" }], // 文本方向
            [
              {
                size: [
                  "12",
                  "14",
                  "16",
                  "18",
                  "20",
                  "22",
                  "24",
                  "28",
                  "32",
                  "36",
                ],
              },
            ], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6] }], // 标题
            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            // [{ font: ['songti'] }], // 字体种类
            [{ align: [] }], // 对齐方式
            ["clean"], // 清除文本格式
            ["image", "video"], // 链接、图片、视频
          ],
        },
        placeholder: "请输入正文",
      },

      headers: { Authorization: "JWT " + localStorage.getItem("adminToken") },
      imagesrc: this.baseUrl + "/admin/uploadfile/news_banner/",
      imgUrl:
        "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news_banner/",
      newimgUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/",
      rules: {
        title: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        info: [{ required: true, message: "请输入活动内容", trigger: "blur" }],
        type: [{ required: true, message: "请输入活动类型", trigger: "blur" }],
        img: [{ required: true, message: "请选择封面图", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 返回列表页
    back() {
      this.$router.push({ name: "admin_eventManage" });
    },
    // 提交公告发布表单
    onBaseSubmit(formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          let url = this.baseUrl + "/admin/news/";
          api
            .postData(url, {
              title: this.form.title,
              type: this.form.type,
              info: this.form.info,
              img: this.form.img,
            })
            .then((res) => {
              this.$message({
                message: "公告发布成功",
                type: "success",
              });
              // 展商端列表页已下线，统一回到小程序端新闻列表
              this.$router.push({
                name: "admin_eventManage",
                query: { type: 1 },
              });
            });
        }
      });
    },
    // 富文本编辑器上传图片回调函数
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      let url = this.baseUrl + "/admin/uploadfile/news/";
      const formData = new FormData();
      formData.append("file", file);
      api.postData(url, formData).then((res) => {
        Editor.insertEmbed(
          cursorLocation,
          "image",
          this.newimgUrl + res.filename
        );
        resetUploader();
      });
    },
    // 图片上传成功回调
    handleAvatarSuccess(res, file) {
      let imageUrl = URL.createObjectURL(file.raw);
      this.form.img = res.filename;
    },
    // 图片上传前校验
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg/png';
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!');
      // }
      // return isJPG && isLt2M;
    },

    // 更新富文本编辑器内容
    updateData: function (data) {
      this.form.info = data;
    },

    // 全屏显示编辑器
    fullScreen: function () {
      this.$refs.editor.enableFullScreen();
    },
    // 编辑器获取焦点
    focus: function () {
      this.$refs.editor.focus();
    },
    // 重置编辑器内容
    reset: function () {
      var newContent = prompt("please input some html code: ");
      if (newContent) {
        this.content = newContent;
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/addStationInfo.vue